// Centralized external destination map (single source of truth).
// The marketing site is the conversion layer; these endpoints handle auth,
// checkout and the product hub. Tenant is 'kalkiai'.

const BASE = 'https://bsct.cloud';
const T = 'kalkiai';

export const EXT = {
  SIGNUP: `${BASE}/embed/signup?t=${T}`,
  LOGIN: `${BASE}/embed/login?t=${T}`,
  FORGOT_PASSWORD: `${BASE}/embed/forgot-password?t=${T}`,
  DASHBOARD: `${BASE}/t/${T}/hub`,
  AFFILIATE: `${BASE}/embed/affiliate?t=${T}`,
  CONTACT: `${BASE}/embed/contact?t=${T}`,
  COINS: `${BASE}/embed/coin?t=${T}`,
  EXCHANGE: `${BASE}/embed/exchange?t=${T}`,
  PRICING_TOUR: `${BASE}/embed/pricing?t=${T}`,
};

export const checkout = (plan, method) =>
  `${BASE}/api/checkout/direct?plan=${plan}&method=${method}&t=${T}`;

export const CHECKOUT = {
  PRO_STRIPE: checkout('pro', 'stripe'),
  PRO_MAX_STRIPE: checkout('pro_max', 'stripe'),
  PRO_CRYPTO: checkout('pro', 'crypto'),
  PRO_MAX_CRYPTO: checkout('pro_max', 'crypto'),
};

// Open an external destination + fire a lightweight analytics event.
export const openExternal = (url, event) => {
  try {
    if (event && typeof window !== 'undefined') {
      if (window.posthog?.capture) window.posthog.capture(event);
      if (window.gtag) window.gtag('event', event);
    }
  } catch (e) { /* no-op */ }
  if (typeof window !== 'undefined') window.open(url, '_blank', 'noopener,noreferrer');
};
